import { render, staticRenderFns } from "./LiveHedgingBlock.vue?vue&type=template&id=390b9060&scoped=true"
import script from "./LiveHedgingBlock.vue?vue&type=script&lang=js"
export * from "./LiveHedgingBlock.vue?vue&type=script&lang=js"
import style0 from "./LiveHedgingBlock.vue?vue&type=style&index=0&id=390b9060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b9060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCardTitle,VCol,VRow,VSpacer})
